import { render, staticRenderFns } from "./POS-Checkout.vue?vue&type=template&id=5484bbc5&"
import script from "./POS-Checkout.vue?vue&type=script&lang=js&"
export * from "./POS-Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports